export const MULTI_FILTER_TYPES = ['categories', 'sections', 'brands', 'contents', 'manufacturers'] as const;

export const MULTI_FILTER_PLACEHOLDERS: Record<(typeof MULTI_FILTER_TYPES)[number], string> = {
  categories: 'Categoria',
  sections: 'Seção',
  brands: 'Marca',
  contents: 'Conteúdo',
  manufacturers: 'Fabricante',
};

export const MULTI_FILTER_SELECTED_PLACEHOLDERS: Record<(typeof MULTI_FILTER_TYPES)[number], string> = {
  categories: 'Categorias',
  sections: 'Seções',
  brands: 'Marcas',
  contents: 'Conteúdos',
  manufacturers: 'Fabricantes',
};

export const MULTI_FILTERS_TRACKER_AREA = 'elasticidade-multi-filters';

export const SEGMENTS_TRACKER_AREA = 'elasticidade-segments';

export const PRODUCT_REFERENCE_TRACKER_AREA = 'product-reference-filter';

export const TABLE_TRACKER_AREA = 'elasticidade-table';

export const DEFAULT_TABLE_PAGE = 0;
export const DEFAULT_TABLE_PAGE_SIZE = 10;

export const TABLE_SORTABLE_COLUMNS = {
  referenceProduct: 'referenceProduct',
  topCompetitor: 'topCompetitor',
  salesVolumeElasticityLevel: 'salesVolumeElasticityLevel',
  salesVolumeCurrentCpi: 'salesVolumeCurrentCpi',
  salesVolumeOptimalCpi: 'salesVolumeOptimalCpi',
  salesVolumePotentialGain: 'salesVolumePotentialGain',
} as const;

export const PRODUCT_REFERENCE_DEFAULT_SIZE = 50;
export const PRODUCT_REFERENCE_LOAD_MORE_INCREMENT = 100;
export const PRODUCT_REFERENCE_MAX_SIZE = 1000;
export const PRODUCT_REFERENCE_MAX_SELECTED = 10;

export const COMPETITOR_OPTIONS = [
  {
    value: 'produto-concorrente',
    label: 'Top produto concorrente',
  },
  {
    value: 'media-precos-concorrentes',
    label: 'Média de preços dos produtos concorrentes',
  },
];

export const MARKET_SHARE_OPTIONS = [
  {
    value: 'valor-vendas',
    label: 'Valor de vendas',
    description: 'Com base na receita de vendas',
  },
  {
    value: 'volume-vendas',
    label: 'Volume de vendas',
    description: 'Com base na quantidade de unidades vendidas',
  },
];

export type CompetitivityMenuItem = { value: string; label: string };

export const COMPETITIVITY_MENU_ITEMS: CompetitivityMenuItem[] = [
  { value: 'MAIOR_OU_IGUAL_A', label: 'Maior ou igual' },
  { value: 'MENOR_OU_IGUAL_A', label: 'Menor ou igual' },
  { value: 'ENTRE', label: 'Entre' },
];
